<template>
    <div class="card-header">
        <div class="bg">
            <common-icon name="search-gray" size="large" class="header-search-layout"></common-icon>
            <input v-model="search" type="text" placeholder="Search Patient" class="search" @input="onSearchInput" />
        </div>
    </div>
</template>
<script>
    import debounce from 'lodash.debounce'
    import config from '../../../config'

    export default {
        data() {
            return {
                search: '',
            }
        },
        methods: {
            onSearchInput: debounce(function () {
                this.$emit('search', this.search)
            }, config.DEBOUNCE.DEFAULT),
        },
    }
</script>
